import React, {FunctionComponent} from "react"

type ErrorType = {
	message?: string
}

interface TextInputProps {
	required: boolean
	error: ErrorType
	name: string
	title: string
	disabled?: boolean
	register: any
}

const TextInput: FunctionComponent<TextInputProps> = ({required, error, title, name, disabled = false, register}) => {
	return (
		<div className='row field-add-user'>
			<div className='field-row'>
				<div className='field-input-wrapper'>
					<div className='field-label-wrapper'>
						<label htmlFor={name}>{title}</label>
						{required && <div className='field-required'>Required</div>}
					</div>
					<div className='field-message-wrapper'>
						<input type='text' id={name} name={name} disabled={disabled} {...register(name)} />
						{error && <p className='field-error'>{error.message}</p>}
					</div>
				</div>
			</div>
		</div>
	)
}

export default TextInput
